import React from 'react';
import PropTypes from 'prop-types';
import PageHeader from '../../components/PageHeader/PageHeader';

const propTypes = {
  returnLink: PropTypes.string,
  returnText: PropTypes.string,
  errorMessage: PropTypes.string,
  titleWidth: PropTypes.string,
};

type ErrorPageProps = PropTypes.InferProps<typeof propTypes>;

function ErrorPage({
  returnText,
  returnLink,
  errorMessage,
  titleWidth,
}: ErrorPageProps) {
  document.title = 'Marshall Insights | Error';
  return (
    <div className="page page-not-authorized">
      <PageHeader
        title="500: Internal Server Error"
        returnText={returnText}
        returnLink={returnLink}
        titleWidth={titleWidth}
      />
      <div className="error-message-container">
        <p>
          {errorMessage}
        </p>
      </div>
    </div>
  );
}

ErrorPage.defaultProps = {
  returnText: 'Back to Home',
  returnLink: '/',
  errorMessage: 'Something went wrong with this page.',
  titleWidth: 'col-6',
};

export default ErrorPage;
